import React from 'react';
import { StyleProp, StyleSheet, TouchableOpacity, View, ViewStyle } from 'react-native';

import Text from '@/components/Text';
import { formatCurrency } from '@/utils/currencyFormat';

//Interfaces
interface ImpactCardColumnProps {
  qty: number;
  title: string;
  amount: number;
  twoColumns?: boolean;
  onPress?: () => void;
}

interface ImpactCardProps {
  children: React.JSX.Element | React.JSX.Element[];
  style?: StyleProp<ViewStyle>;
}

//Components
const ImpactCardColumn = ({ qty, title, amount, twoColumns = false, onPress }: ImpactCardColumnProps) => (
  <View style={style.impactCardColumn}>
    <TouchableOpacity
      style={style.impactCardTouchable}
      onPress={() => {
        if (onPress) onPress();
      }}
      disabled={!onPress}>
      <Text style={[style.cardColumnNumber, { fontSize: twoColumns ? 40 : 27 }]} fontWeight="900">
        {qty}
      </Text>
      <Text style={[style.cardColumnTitle, { fontSize: twoColumns ? 20 : 12 }]} fontWeight="900">
        {title}
      </Text>
      <View style={[style.cardColumnAmount, { height: twoColumns ? 36 : 24 }]}>
        <Text style={[style.cardColumnAmountText, { fontSize: twoColumns ? 20 : 14 }]} fontWeight="900">
          {formatCurrency(amount)}
        </Text>
      </View>
    </TouchableOpacity>
  </View>
);

const ImpactCard = ({ children, style: customStyle }: ImpactCardProps) => {
  const twoColumns = React.Children.count(children) === 2;

  return (
    <View
      style={[
        style.impactCard,
        { columnGap: twoColumns ? 40 : 22, paddingHorizontal: twoColumns ? 20 : 14 },
        customStyle
      ]}>
      {React.Children.map(children, (child) => React.cloneElement(child, { twoColumns }))}
    </View>
  );
};

export { ImpactCard, ImpactCardColumn };

const style = StyleSheet.create({
  impactCard: {
    flexDirection: 'row',
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.12,
    shadowRadius: 10,
    width: '100%',
    paddingBottom: 21,
    paddingTop: 14,
    backgroundColor: 'white',
    elevation: 3
  },
  impactCardColumn: {
    flex: 1
  },
  impactCardTouchable: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: 6
  },

  cardColumnNumber: {
    fontSize: 27,
    color: 'black'
  },
  cardColumnTitle: {
    color: 'black'
  },
  cardColumnAmount: {
    backgroundColor: 'black',
    borderRadius: 7,
    width: '100%',
    height: 25,
    justifyContent: 'center',
    alignItems: 'center'
  },
  cardColumnAmountText: {
    fontSize: 14,
    color: 'white'
  }
});
